import { useState } from "react";

export default function OutgrowError404() {
  const [iframeVisible, setIframeVisible] = useState(false);

  return (
    <section className="new-404-block outgrow-error-screen">
      <div className="new-404-header">
        <div className="container-fluid">
          <div className="navbar-header">
            <a className="params navbar-brand" href="//outgrow.co">
              <img
                src="https://dlvkyia8i4zmz.cloudfront.net/klIvsXsSSymUC8HaCeYw_outgrow_976x240.svg"
                alt="logo"
              />
            </a>
          </div>
        </div>
      </div>
      <div className="new-404-body">
        <div className="container-fluid">
          <div className="new-404-row">
            <div className="custm-container">
              <div className="new404-aligned">
                <div className="new-404-msg">
                  <div className="new404-side-border-outer">
                    <div className="new404-side-border new-404-mr8"></div>
                    <div className="new404-side-border"></div>
                  </div>
                  <h3>404</h3>
                  <div className="new404-side-border-outer">
                    <div className="new404-side-border"></div>
                    <div className="new404-side-border new-404-mr8"></div>
                  </div>
                </div>
                <div className="new-404-contnt">
                  <p>
                    Woah, you seem to have hit a dead end. That's okay though,
                    you can always head back home.
                  </p>
                </div>
                <div className="new404-home-buttn">
                  <a href="https://outgrow.co/">Go To Home</a>
                </div>
              </div>
              <div className="new-404-image height_404">
                {!iframeVisible && (
                  <>
                    <img
                      src="https://outgrow.co/images/404-bg-icn.png"
                      className="new404-icn-img"
                    />
                    <img
                      src="https://dlvkyia8i4zmz.cloudfront.net/fvvcW4ER7G6eM3qd5yUg_image__3_.png"
                      useMap="#image-map"
                      alt="calc image"
                      width="100%"
                      className="image404_outgrow"
                    />
                    <map name="image-map">
                      <area
                        alt="show me what you got"
                        onClick={() => setIframeVisible(true)}
                        href="javascript:void(0)"
                        coords="193,406,443,354"
                        shape="rect"
                      />
                    </map>
                  </>
                )}
                {iframeVisible && (
                  <iframe
                    src="https://premade.outgrow.us/quiz-for-404-page"
                    frameBorder="0"
                    style={{
                      width: "100%",
                      minHeight: "600px",
                      border: "none",
                    }}
                  ></iframe>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
